<div class="training-dashboard-container">
  <div class="dashboard-header">
    <div class="header-content">
      <div>
        <h1>Training Dashboard</h1>
        <p class="subtitle">Manage employee training and track course progress</p>
      </div>
      <div *ngIf="!isEmployeeView" class="notification-header-wrap">
        <button mat-icon-button class="notification-trigger" (click)="toggleNotificationsPanel()" [matTooltip]="'Training requests'">
          <mat-icon>notifications</mat-icon>
          <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
        </button>
        <div *ngIf="showNotificationsPanel" class="notification-panel" (click)="$event.stopPropagation()">
          <div *ngIf="notifications.length === 0" class="notification-empty">No notifications</div>
          <div *ngFor="let n of notifications" class="notification-item" [class.read]="n.read_at" (click)="markNotificationViewed(n)">
            <span class="notification-message">{{ n.message }}</span>
            <span class="notification-date">{{ formatNotificationDate(n.created_at) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Loading...</p>
  </div>

  <div *ngIf="!loading" class="dashboard-content">
    <!-- Employee Training Progress Section -->
    <section class="employee-progress-section">
      <h2>Employee Training Progress</h2>
      <div *ngIf="employees.length > 0" class="search-bar-container">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput placeholder="Search by name" [(ngModel)]="searchText" />
          <button mat-icon-button matSuffix *ngIf="searchText" (click)="searchText = ''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div *ngIf="employees.length === 0" class="no-employees-message">
        <p>No employees found. Employees will appear here once they are assigned to you.</p>
      </div>
      <div *ngIf="employees.length > 0" class="employee-cards-grid">
        <div
          *ngFor="let employee of filteredEmployees" 
          class="employee-card"
          [class.has-course]="(employee.course_name && employee.is_training) && employee.progress_pct < 100"
          [class.clickable]="isCardClickable(employee)"
          (click)="isCardClickable(employee) && viewEmployeeDetail(employee)">
          <div class="employee-card-content">
          <div class="employee-card-header">
            <h3 class="employee-name">{{ employee.employee_name || 'Unknown Employee' }}</h3>
            <mat-icon *ngIf="(employee.course_name && employee.is_training) && employee.progress_pct < 100" class="graduation-icon">school</mat-icon>
          </div>
            <div class="training-level-section">
              <p class="training-level-label">Training Level</p>
              <p class="training-level-value">{{ formatTrainingLevel(employee.training_level) }}</p>
            </div>

            <div *ngIf="getBadgesFromLevel(employee.training_level) as badges" class="completed-badges-section">
              <ng-container *ngFor="let badge of badges">
                <div class="badge-wrapper" [title]="badge.name">
                  <img [src]="badge.image" [alt]="badge.name" class="cert-badge" />
                </div>
              </ng-container>
            </div>
            
            <div *ngIf="employee.course_name" class="current-course-section">
              <div class="course-progress-header">
                <p class="current-course-label">{{ employee.progress_pct >= 100 ? 'Completed Course' : 'Current Course' }}</p>
                <span class="progress-percentage">{{ (employee.progress_pct != null ? employee.progress_pct : 0) }}%</span>
              </div>
              <p class="course-name">{{ employee.course_name }}</p>
              <div class="progress-bar-container">
                <div 
                  class="progress-bar" 
                  [style.width.%]="employee.progress_pct != null ? employee.progress_pct : 0">
                </div>
              </div>
            </div>
            
            <button 
              *ngIf="!isEmployeeView && (!employee.course_name || !employee.is_training)"
              mat-stroked-button
              class="begin-course-button"
              (click)="openBeginCourseModal(employee); $event.stopPropagation()">
              Begin Course
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Available Courses Section (admin/manager only) -->
    <section *ngIf="!isEmployeeView" class="available-courses-section">
      <div class="courses-card">
        <div class="courses-card-header">
          <mat-icon class="book-icon">menu_book</mat-icon>
          <div>
            <h3 class="courses-title">Available Courses</h3>
            <p class="courses-subtitle">Browse and manage training courses</p>
          </div>
        </div>
        <div class="courses-list" *ngIf="courses.length > 0">
          <div *ngFor="let course of courses" class="course-item">
            <div class="course-info">
              <p class="course-item-name">{{ course.name }}</p>
              <p class="course-item-duration">{{ course.duration_days }} days</p>
            </div>
            <button 
              mat-stroked-button 
              class="course-details-button"
              (click)="viewCourseDetails(course)">
              Details
            </button>
          </div>
        </div>
        <div *ngIf="courses.length === 0" class="no-courses-message">
          <p>No courses available</p>
        </div>
      </div>
    </section>
  </div>
</div>
